import React from 'react';
import StartYourRegistryHero from '../StartYourRegistryHero/StartYourRegistryHero';
import RegistryTestimonialsSection from '../RegistryTestimonialsSection/RegistryTestimonialsSection';
import WhyZolaRegistrySection from '../WhyZolaRegistrySection/WhyZolaRegistrySection';

// TODO: add lazyloading
const RegistryOnboardVariationTemplate = ({ children }) => {
  return (
    <div>
      <StartYourRegistryHero />
      {children}
      <WhyZolaRegistrySection />
      <RegistryTestimonialsSection />
    </div>
  );
};

export default RegistryOnboardVariationTemplate;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/RegistryOnboardVariationTemplate/RegistryOnboardVariationTemplate.jsx